import { addHours, isBefore } from 'date-fns';
/** Staff can't drop a claimed task this close to its start. */
export const UNCLAIM_CUTOFF_HOURS = 24;
export const isWithinUnclaimCutoff = (startTime, now) => isBefore(startTime, addHours(now, UNCLAIM_CUTOFF_HOURS));
/** Claims left; a task with no headcount takes one. */
export const openSpots = (staffNeeded, assignedCount) => Math.max(0, (staffNeeded ?? 1) - assignedCount);
/** A form's headcount as a whole number of at least one. */
export const toStaffNeeded = (value) => Math.max(1, Math.trunc(Number(value)) || 1);
/** The no-login schedule link, festival-scoped when given one. */
export const staffSchedulePath = ({ organizationId, token, festivalId, }) => festivalId
    ? `/staff/${organizationId}/schedule/${token}?festivalId=${festivalId}`
    : `/staff/${organizationId}/schedule/${token}`;
/** Rides carry rider contacts, so a full one stays private. */
export const TRANSPORT_TASK_TYPES = [
    'Dropoff At Airport',
    'Pickup From Airport',
    'Transport',
    'Deliver Food',
];
const transportTypes = TRANSPORT_TASK_TYPES;
export const isTransportTask = (task) => !!task && transportTypes.includes(task.type);
//# sourceMappingURL=claims.js.map